import Router from 'vue-router';

import store from '@/store';

/**
 * If already authenticated directly redirect to app
 * @param to
 * @param from
 * @param next
 */
const ifAuthenticated = (to, from, next) => {
    if (!store.getters['auth/loggedIn']) {
        if (to.params.signInModal) {
            if (localStorage.getItem('invitation') !== null) {
                next('invitation/' + localStorage.getItem('invitation'));
            } else {
                next();
            }
        } else {
            next();
        }
        return;
    }
    next('/');
}

const routes = [
    {
        path: '/',
        component: () => import('@/layouts/AppLayout'),
        meta: {
            requiresAuth: false
        },
        children: [
            {
                path: '',
                name: 'app',
                component: () => import( '@/pages/Start.vue' ),
                meta: {
                    requiresAuth: false
                },
                children: [
                    {
                        path: 'auth',
                        children: [
                            {
                                path: 'signin',
                                name: 'signin',
                                meta: {
                                    requiresAuth: false
                                },
                                component: () => import('@/components/modals/SignInModal'),
                                beforeEnter: ifAuthenticated
                            },
                            {
                                path: 'forgot-password',
                                name: 'forgot-password',
                                meta: {
                                    requiresAuth: false
                                },
                                component: () => import('@/components/modals/ForgotPasswordModal')
                            }
                        ],
                        component: () => import('@/components/shared/RouterView'),
                    },
                    {
                        path: 'invitation/:uid',
                        name: 'invitation',
                        async beforeEnter(to, from, next) {
                            let uid = to.params.uid;
                            // Einladung wird geöffnet
                            if (uid !== null && typeof uid !== 'undefined') {
                                // Prüfe ob Einladung bereits geöffnet
                                //let currentInvitationId = localStorage.getItem('invitation');
                                let currentInvitationId = localStorage.getItem('invitation');
                                let isActiveInvitation = store.getters['app/isActiveInvitation'];
                                if (isActiveInvitation && currentInvitationId === uid) {
                                    // Weiterleiten auf Startseite
                                    next();
                                } else {
                                    // Erstmaliger Besuch mit Einladungslink
                                    await store.dispatch('app/setupInvitation', uid);
                                    next('/');

                                }
                            }
                        },
                        component: () => import('@/components/modals/RegisterModal')
                    }
                ]
            },
            {
                path: 'filter',
                name: 'filter',
                component: () => import( '@/pages/Filter.vue' ),
                meta: {
                    requiresAuth: false
                }
            },
            {
                path: 'missions',
                name: 'missions',
                meta: {
                    requiresAuth: false
                },
                component: () => import('@/pages/MissionResult')
            },
            {
                path: 'missions/:mission_id',
                name: 'missionsDetail',
                meta: {
                    requiresAuth: true
                },
                component: () => import('@/pages/MissionDetail')
            },
            {
                path: 'applications',
                name: 'applications',
                meta: {
                    requiresAuth: true
                },
                component: () => import( '@/pages/Applications.vue' )
            },
            {
                path: 'favorites',
                name: 'favorites',
                meta: {
                    requiresAuth: true
                },
                component: () => import( '@/pages/Favorites.vue' )
            },
            {
                path: 'excluded',
                name: 'excluded',
                meta: {
                    requiresAuth: true
                },
                component: () => import( '@/pages/Excluded.vue' )
            },
            {
                path: 'profile',
                name: 'profile',
                meta: {
                    requiresAuth: true
                },
                component: () => import( '@/pages/Profile.vue' )
            },
            {
                path: 'corona',
                name: 'corona',
                meta: {
                    requiresAuth: false
                },
                component: () => import( '@/pages/Corona.vue' )
            },
            {
                path: 'info',
                name: 'info',
                component: () => import( '@/pages/Info.vue' )
            }
        ]
    },
];

const router = new Router({
    routes: [
        ...routes,
        {
            path: '*',
            component: () => import('@/layouts/AppLayout'),
            children: [
                {
                    path: '',
                    component: () => import('@/components/cards/PageNotFoundCard')
                }
            ]
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters['auth/loggedIn']) {
            next();
            return;
        }

        let isActiveInvitation = store.getters['app/isActiveInvitation'];
        let invitationId = store.getters['app/GET_INVITATION'];

        if (isActiveInvitation) {
            next('/invitation/' + invitationId);
        } else {
            next('/auth/signin?redirect=' + to.fullPath);
        }
    } else {
        next();
    }
});

export default router;
export {routes};